export default __webpack_public_path__ + "static/media/gallery_1_768.4f663897.webp";